import type { AgentChatMessage } from '../../agent/useAgentChat';

/**
 * The turn the onboarding page sends for the customer when it opens on an
 * empty conversation, so the assistant asks its first question straight away
 * instead of waiting for a click. It is a real turn in the session (the model
 * answers it), but the customer never typed it, so no surface shows it.
 */
export const ONBOARDING_KICKOFF = "Hi, I'm ready to set up my workspace.";

/** The conversation as the customer should see it: without the kickoff turn. */
export function withoutKickoff<T extends Pick<AgentChatMessage, 'role' | 'content'>>(
  messages: T[],
): T[] {
  const first = messages[0];
  return first?.role === 'user' && first.content === ONBOARDING_KICKOFF
    ? messages.slice(1)
    : messages;
}
